import { NETWORK, CUR_NETWORK, SERVICE_ALIAS, API, DEVICE_TYPE } from '@constants/index';

export const getBaseName = (option: IOption) => {
  return `${option?.path}/${CUR_NETWORK === NETWORK.OPDEV ? '' : 'search'}`;
};

// FE에서 사용하는 alias (router/탭/url 등)
export const ALIAS = {
  INDEX: 'index',
  POWERBOOK: 'powerbook',
  COMMUNITY: 'community',
  TAG: 'tagList', // controller 처리 시 /search/tag, /search/tagContent 제외하고 /search/index로 가기 위해 tagList로 변경
  FAQ: 'faq',
  GUIDEBOOK: 'guidebook',
  DICTIONARY: 'dictionary',
  CHARACTER: 'character',
  LEGION: 'legions', // 레기온
  GUILD: 'guild', // 문파
  NPUSER: 'npuser', // 사람
  NCTV: 'nctv', // 아이온/블소 - NCTV
  VIDEO: 'video', // 리니지m-동영상
  EVENT: 'event', // 이벤트
  IMAGE: 'image',
  TRADE: 'trade', // 리니지 - 시세(로그인 시 노출)

  // 자동완성
  TOTAL: 'total', // 통합
  EQUIP: 'equip', // 장비

  // 커뮤니티 게시판 호출 alias 필요
  COMMUNITY_BOARD_ALIAS: 'communityBoardAlias',
};

// "전체" api에서 내려오는 데이터 필드값(BE) (FE에서 사용하는 alias(탭/각 컴포넌트 id)값이 다름)
export const BE_ALIAS = {
  POWERBOOK: 'powerbook',
  COMMUNITY: 'community',
  AWAKENING_COMMUNITY: 'awakeningCommunity',
  TAG: 'tag',
  AWAKENING_TAG: 'awakeningTag',
  FAQ: 'faq',
  GUIDEBOOK: 'guidebook',
  CLASSIC_GUIDEBOOK: 'classicGuidebook',
  AWAKENING_GUIDEBOOK: 'awakeningGuidebook',
  DICTIONARY: 'dictionary',
  CHARACTER: 'character',
  NPUSER: 'npuser',
  GUILD: 'guild', // 아이온 - 레기온, 블소 - 문파
  VIDEO: 'video',
  PROMOTION: 'promotion', // 이벤트
  IMAGE: 'image',
  TRADE: 'trade',
  CONTENT_LIST: 'contentlist', // 연대기
  NSHOP: 'nshop', // 기존 N샵(탭에는 존재하지 않고, index에서만 api 호출함)
  GOODS: 'goods', // 통합 N샵
  MOVIE: 'movie', // 리니지M - 동영상
  DIRECT: 'direct',
  NEO_GUIDEBOOK: 'neoGuidebook', // 블소 네오 - 가이드북
  NEO_GUILD: 'neoGuild', // 블소 네오 - 문파
  NEO_GOODS: 'neoGoods',  // 블소 네오 - 서버 통합 N샵
  AWAKENING_GOODS: 'awakeningGoods', // 리니지2 - 각성 서버 통합 N샵
  CLASSIC_GOODS: 'classicGoods' // 아이온 - 클래식 서버 통합 N샵
};

export const SEARCH_PARAMS = {
  KEYWORD: 'keyword',
  ALIAS: 'alias',
  PAGE: 'page',
  SIZE: 'size',
  FIELD: 'field',
  LANGUAGE_CODE: 'languageCode',
  SERVICE_NO: 'serviceNo',
  GAME_NAME: 'gameName',
  COUNTRY: 'country',
  LANGUAGE: 'language',
  SORT: 'sort',
  EXCLUDE_FIELDS: 'exclude-fields',
  END_DATE_FROM: 'endDateFrom',
  VIDEO_KIND: 'videoKind',
  ZONE: 'zone',
  SERVER: 'server',
  SERVER_ID: 'serverId',
  CLASS_ID: 'classId',
  RACE_ID: 'raceId',
  SERVER_TYPE: 'serverType',
  SEARCH_TYPE: 'searchType',
  SERVICE: 'service',
  BOARD_ALIAS: 'boardAlias',
  PREV_CONTENT_ID: 'prevContentId',
  COUNT: 'count',
  IS_VOTE: 'isVote',
  LAST_ITEM_CNT: 'lastItemCnt',
  PAGE_SIZE: 'page_size',
};

const DEFAULT_ROUTE = {
  [ALIAS.INDEX]: {
    key: ALIAS.INDEX,
    l10nKey: ALIAS.INDEX,
    url: `/${ALIAS.INDEX}`,
    api: [API.TOTAL, API.NSHOP],
    searchParams: [SEARCH_PARAMS.KEYWORD],
    showDevice: [DEVICE_TYPE.PC, DEVICE_TYPE.MOBILE],
  },
  [ALIAS.GUIDEBOOK]: {
    key: ALIAS.GUIDEBOOK,
    l10nKey: ALIAS.GUIDEBOOK,
    url: `/${ALIAS.GUIDEBOOK}`,
    api: [API.GUIDEBOOK],
    searchParams: [
      SEARCH_PARAMS.KEYWORD,
      SEARCH_PARAMS.PAGE,
      SEARCH_PARAMS.SIZE,
      SEARCH_PARAMS.FIELD,
      SEARCH_PARAMS.GAME_NAME,
      SEARCH_PARAMS.COUNTRY,
      SEARCH_PARAMS.LANGUAGE,
      SEARCH_PARAMS.SORT,
    ],
    showDevice: [DEVICE_TYPE.PC, DEVICE_TYPE.MOBILE],
  },
  [ALIAS.COMMUNITY]: {
    key: ALIAS.COMMUNITY,
    l10nKey: ALIAS.COMMUNITY,
    url: `/${ALIAS.COMMUNITY}`,
    api: [API.COMMUNITY_API_ALL, API.COMMUNITY_API_ARTICLE],
    searchParams: [
      SEARCH_PARAMS.KEYWORD, // api 전송 시 'query'로 보내야 함
      SEARCH_PARAMS.SEARCH_TYPE,
      SEARCH_PARAMS.PAGE,
      SEARCH_PARAMS.PREV_CONTENT_ID,
      SEARCH_PARAMS.COUNT,
      SEARCH_PARAMS.IS_VOTE,
    ],
    showDevice: [DEVICE_TYPE.PC, DEVICE_TYPE.MOBILE],
  },
  [ALIAS.TAG]: {
    key: ALIAS.TAG,
    l10nKey: ALIAS.TAG,
    url: `/${ALIAS.TAG}`,
    api: [API.COMMUNITY_API_TAG],
    searchParams: [
      SEARCH_PARAMS.KEYWORD, // api 전송 시 'query'로 보내야 함
      SEARCH_PARAMS.LAST_ITEM_CNT,
      SEARCH_PARAMS.PAGE_SIZE,
    ],
    showDevice: [DEVICE_TYPE.PC, DEVICE_TYPE.MOBILE],
  },
  [ALIAS.CHARACTER]: {
    key: ALIAS.CHARACTER,
    l10nKey: ALIAS.CHARACTER,
    url: `/${ALIAS.CHARACTER}`,
    api: [API.CHARACTER],
    searchParams: [
      SEARCH_PARAMS.KEYWORD,
      SEARCH_PARAMS.PAGE,
      SEARCH_PARAMS.SIZE,
      SEARCH_PARAMS.ZONE,
      SEARCH_PARAMS.SERVER_ID,
      SEARCH_PARAMS.CLASS_ID,
      SEARCH_PARAMS.RACE_ID,
      SEARCH_PARAMS.SORT,
    ],
    showDevice: [DEVICE_TYPE.PC, DEVICE_TYPE.MOBILE],
  },
  [ALIAS.VIDEO]: {
    key: ALIAS.VIDEO,
    l10nKey: ALIAS.VIDEO,
    url: `/${ALIAS.VIDEO}`,
    api: [API.VIDEO],
    searchParams: [SEARCH_PARAMS.KEYWORD, SEARCH_PARAMS.PAGE, SEARCH_PARAMS.SIZE, SEARCH_PARAMS.FIELD, SEARCH_PARAMS.SORT],
    showDevice: [DEVICE_TYPE.PC, DEVICE_TYPE.MOBILE],
  },
  [ALIAS.NCTV]: {
    key: ALIAS.NCTV,
    l10nKey: ALIAS.NCTV,
    url: `/${ALIAS.NCTV}`,
    api: [API.NCTV],
    searchParams: [SEARCH_PARAMS.KEYWORD, SEARCH_PARAMS.PAGE, SEARCH_PARAMS.SIZE, SEARCH_PARAMS.FIELD, SEARCH_PARAMS.SORT, SEARCH_PARAMS.VIDEO_KIND],
    showDevice: [DEVICE_TYPE.PC, DEVICE_TYPE.MOBILE],
  },
  [ALIAS.FAQ]: {
    key: ALIAS.FAQ,
    l10nKey: ALIAS.FAQ,
    url: `/${ALIAS.FAQ}`,
    api: [API.FAQ],
    searchParams: [
      SEARCH_PARAMS.KEYWORD,
      SEARCH_PARAMS.PAGE,
      SEARCH_PARAMS.SIZE,
      SEARCH_PARAMS.FIELD,
      SEARCH_PARAMS.LANGUAGE_CODE,
      SEARCH_PARAMS.SERVICE_NO,
    ],
    showDevice: [DEVICE_TYPE.PC],
  },
};

const LINEAGE_ROUTE = [
  DEFAULT_ROUTE[ALIAS.INDEX],
  {
    key: ALIAS.POWERBOOK,
    l10nKey: ALIAS.POWERBOOK,
    url: `/${ALIAS.POWERBOOK}`,
    api: [API.POWERBOOK],
    searchParams: [SEARCH_PARAMS.KEYWORD, SEARCH_PARAMS.PAGE, SEARCH_PARAMS.SIZE, SEARCH_PARAMS.FIELD],
    showDevice: [DEVICE_TYPE.PC, DEVICE_TYPE.MOBILE],
  },
  DEFAULT_ROUTE[ALIAS.COMMUNITY],
  DEFAULT_ROUTE[ALIAS.TAG],
  DEFAULT_ROUTE[ALIAS.FAQ],
];

const LINAGE2_ROUTE = [
  DEFAULT_ROUTE[ALIAS.INDEX],
  DEFAULT_ROUTE[ALIAS.GUIDEBOOK],
  {
    key: ALIAS.DICTIONARY,
    l10nKey: ALIAS.DICTIONARY,
    url: `/${ALIAS.DICTIONARY}`,
    api: [API.DICTIONARY],
    searchParams: [SEARCH_PARAMS.KEYWORD, SEARCH_PARAMS.PAGE, SEARCH_PARAMS.SIZE, SEARCH_PARAMS.SERVER, SEARCH_PARAMS.SERVICE, SEARCH_PARAMS.SORT],
    showDevice: [DEVICE_TYPE.PC, DEVICE_TYPE.MOBILE],
  },
  DEFAULT_ROUTE[ALIAS.COMMUNITY],
  DEFAULT_ROUTE[ALIAS.TAG],
  DEFAULT_ROUTE[ALIAS.FAQ],
];

const BNS_ROUTE = [
  DEFAULT_ROUTE[ALIAS.INDEX],
  DEFAULT_ROUTE[ALIAS.COMMUNITY],
  DEFAULT_ROUTE[ALIAS.TAG],
  DEFAULT_ROUTE[ALIAS.GUIDEBOOK],
  {
    key: ALIAS.GUILD,
    l10nKey: ALIAS.GUILD,
    url: `/${ALIAS.GUILD}`,
    api: [API.GUILD],
    searchParams: [SEARCH_PARAMS.KEYWORD, SEARCH_PARAMS.PAGE, SEARCH_PARAMS.SIZE, SEARCH_PARAMS.SERVER_ID, SEARCH_PARAMS.SORT, SEARCH_PARAMS.SERVER_TYPE],
    showDevice: [DEVICE_TYPE.PC, DEVICE_TYPE.MOBILE],
  },
  DEFAULT_ROUTE[ALIAS.FAQ],
];

const AION_ROUTE = [
  DEFAULT_ROUTE[ALIAS.INDEX],
  DEFAULT_ROUTE[ALIAS.GUIDEBOOK],
  DEFAULT_ROUTE[ALIAS.COMMUNITY],
  DEFAULT_ROUTE[ALIAS.TAG],
  {
    key: ALIAS.LEGION,
    l10nKey: ALIAS.LEGION,
    url: `/${ALIAS.LEGION}`,
    api: [API.GUILD],
    searchParams: [SEARCH_PARAMS.KEYWORD, SEARCH_PARAMS.PAGE, SEARCH_PARAMS.SIZE, SEARCH_PARAMS.SERVER_ID, SEARCH_PARAMS.RACE_ID, SEARCH_PARAMS.SORT],
    showDevice: [DEVICE_TYPE.PC, DEVICE_TYPE.MOBILE],
  },
  DEFAULT_ROUTE[ALIAS.FAQ],
];

const LINEAGEM_ROUTE = [
  DEFAULT_ROUTE[ALIAS.INDEX],
  {
    key: ALIAS.EVENT,
    l10nKey: ALIAS.EVENT,
    url: `/${ALIAS.EVENT}`,
    api: [API.EVENT],
    searchParams: [SEARCH_PARAMS.KEYWORD, SEARCH_PARAMS.PAGE, SEARCH_PARAMS.SIZE, SEARCH_PARAMS.END_DATE_FROM],
    showDevice: [DEVICE_TYPE.PC, DEVICE_TYPE.MOBILE],
  },
  DEFAULT_ROUTE[ALIAS.GUIDEBOOK],
  DEFAULT_ROUTE[ALIAS.TAG],
  DEFAULT_ROUTE[ALIAS.COMMUNITY],
  DEFAULT_ROUTE[ALIAS.VIDEO],
  DEFAULT_ROUTE[ALIAS.FAQ],
];

export const ROUTE = {
  [SERVICE_ALIAS.LINEAGE]: LINEAGE_ROUTE,
  [SERVICE_ALIAS.LINEAGE2]: LINAGE2_ROUTE,
  [SERVICE_ALIAS.BNS]: BNS_ROUTE,
  [SERVICE_ALIAS.AION]: AION_ROUTE,
  [SERVICE_ALIAS.LINEAGEM]: LINEAGEM_ROUTE,
};

// "전체" 탭 - 콘텐츠 정렬 순서 (NShop/Goods 제외 - 최상단 위치)
export const TOTAL_SORT = {
  [SERVICE_ALIAS.LINEAGE]: [
    BE_ALIAS.GOODS,
    BE_ALIAS.PROMOTION,
    BE_ALIAS.CONTENT_LIST,
    BE_ALIAS.POWERBOOK,
    BE_ALIAS.TRADE,
    BE_ALIAS.COMMUNITY,
    BE_ALIAS.TAG,
    BE_ALIAS.FAQ,
  ],
  [SERVICE_ALIAS.LINEAGE2]: [
    BE_ALIAS.GOODS,
    BE_ALIAS.AWAKENING_GOODS,
    BE_ALIAS.PROMOTION,
    BE_ALIAS.CONTENT_LIST,
    BE_ALIAS.GUIDEBOOK,
    BE_ALIAS.AWAKENING_GUIDEBOOK,
    BE_ALIAS.DICTIONARY,
    BE_ALIAS.COMMUNITY,
    BE_ALIAS.AWAKENING_COMMUNITY,
    BE_ALIAS.TAG,
    BE_ALIAS.FAQ,
  ],
  [SERVICE_ALIAS.BNS]: [
    BE_ALIAS.NEO_GOODS,
    BE_ALIAS.GOODS,
    BE_ALIAS.PROMOTION,
    BE_ALIAS.CONTENT_LIST,
    BE_ALIAS.COMMUNITY,
    BE_ALIAS.TAG,
    BE_ALIAS.NEO_GUIDEBOOK,
    BE_ALIAS.GUIDEBOOK,
    BE_ALIAS.NEO_GUILD,
    BE_ALIAS.GUILD,
    BE_ALIAS.FAQ,
  ],
  [SERVICE_ALIAS.AION]: [
    BE_ALIAS.CLASSIC_GOODS,
    BE_ALIAS.GOODS,
    BE_ALIAS.PROMOTION,
    BE_ALIAS.CLASSIC_GUIDEBOOK,
    BE_ALIAS.GUIDEBOOK,
    BE_ALIAS.COMMUNITY,
    BE_ALIAS.TAG,
    BE_ALIAS.GUILD,
    BE_ALIAS.FAQ,
  ],
  [SERVICE_ALIAS.LINEAGEM]: [
    BE_ALIAS.PROMOTION, 
    BE_ALIAS.GUIDEBOOK, 
    BE_ALIAS.COMMUNITY, 
    BE_ALIAS.TAG, 
    BE_ALIAS.MOVIE, 
    BE_ALIAS.FAQ
  ],
};

export const AUTOSUGGEST_ALIAS = {
  [ALIAS.TOTAL]: 'total',
};
